<template>
  <header class="header">
    <img src="@/assets/logo.svg" alt />
    <div>
      <h1>{{ about.competition }}</h1>
      <h2>{{ about.location }}, {{ about.date }}</h2>
    </div>
    <div class="nav">
      <a href="https://tupostrzelasz.pl/" target="_blank">
        <font-awesome-icon icon="info-circle" />
        <span>Mapa zawodów łuczniczych</span>
      </a>
    </div>
  </header>
</template>

<script>
export default {
  name: 'Header',
  computed: {
    about() {
      return this.$store.state.about
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/scss/_variables.scss';
@import '@/scss/_mixins.scss';

.header {
  width: 100%;
  background-color: #fff;
  height: 64px;
  grid-column: 1/3;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  font-weight: 700;
  position: relative;
  z-index: 10000;
  font-size: 0.9em;
  border-bottom: solid 1px #edeff6;

  @media #{$media-sm} {
    height: 54px;
    grid-column: 1/2;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 1000;
  }

  img {
    height: 32px;
    padding: 16px;
    padding-bottom: 15px;
    margin-right: 16px;
    border-right: solid 1px #f4f5f6;
    border-bottom: solid 1px #f4f5f6;

    @media #{$media-sm} {
      // height: 24px;
      width: 23px;
      height: calc(100% - 18px);
      padding: 9px;
    }
  }

  h1 {
    margin: 0;
    font-size: 1em;
    transition: 0.3s;
    text-align: left;

    @media #{$media-md} {
      font-size: 0.8em;
    }

    &:empty {
      background-color: #f2f2f2;
      width: 200px;
      height: 20px;
      border-radius: 4px;
    }
  }

  h2 {
    margin: 0;
    font-size: 0.7em;
    text-align: left;
    transition: 0.3s;

    @media #{$media-md} {
      font-size: 0.6em;
    }

    &:empty {
      background-color: #f2f2f2;
      width: 100px;
      height: 16px;
      margin-top: 1px;
      border-radius: 4px;
    }
  }

  .nav {
    margin-left: auto;
    display: flex;
    margin-right: 16px;

    @media #{$media-md} {
      margin-right: 8px;
    }

    a {
      display: block;
      padding: 10px;
      color: var(--dark);
      text-decoration: none;
      transition: 0.3s;
      display: inline-flex;
      justify-content: center;
      align-items: center;

      span {
        margin-left: 8px;

        @media #{$media-sm} {
          display: none;
        }
      }

      &:hover {
        color: var(--primary);
      }

      &.router-link-active {
        color: var(--orange);
      }
    }
  }
}
</style>
